import React, { useEffect, useMemo, useState, useCallback } from "react";
import {
  ajoutMaintienAffectation,
  ajoutMaintienQuestion,
  getListeMaintienQuestion,
} from "../../../../../data/exercice";
import swal from "sweetalert";
import { succesMessage } from "../../../../../helpers/AssetsHelpers";
import {
  Button,
  Divider,
  Input,
  notification,
  Select,
  Skeleton,
  Space,
  Typography,
} from "antd";
import { Identification } from "../../Identification";
import QuestionnaireMaintien from "./EB2/QuestionnaireMaintien";
import DecisionMaintienRefus from "./EB2/DecisionMaintienRefus";
import { getListeIdentificationSommaire } from "../../../../../data/rateau";
import useUsers from "../../../../../hooks/users/useUser";
import {
  faIdCard,
  faTasks,
  faUserCircle,
} from "@fortawesome/free-solid-svg-icons";
import FileUploadQuestionnaire from "./EB1/FileUploadQuestionnaire";
import { StepBody, StepHeader } from "../../../../common/Step.components";
import { appTheme } from "../../../../../config/theme";
import { Spinner } from "@chakra-ui/react";
import PageToolbarHeader from "../../../../modals/PageToolbarHeader";
import ModalNavBarMenu from "../../../../modals/ModalNavBarMenu";
import FormLabel from "../../../../common/Form/FormLabel";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import UserCycleIdentification from "../../UserCycleIdentification";

const { Title } = Typography;

const questionAcceptations = [
  {
    id: 1,
    libelleGroupe:
      "Le questionnaire initial d'acceptation de la mission a-t-il été revu, actualisé et joint au présent document ?",
    libelle:
      "Le questionnaire initial d'acceptation de la mission a-t-il été revu, actualisé et joint au présent document ?",
  },
  {
    id: 2,
    libelleGroupe:
      "De manière plus spécifique, les aspects suivants ont-ils été évalués :",
    libelle:
      "Les travaux d’audit ont-ils révélé des problèmes d’indépendance ?\n" +
      "Plus particulièrement,\n" +
      "•\tle cabinet est-il indépendant en matière des modalités de paiement d'honoraires, incluant tout arriéré significatif d'honoraires\n" +
      "•\tqu'aucun associé ou membre de l'équipe d'audit a des relations familiales ou d'affaires avec le client\n" +
      "•\tqu'aucun associé ou membre de l'équipe d'audit n'a d'intérêts financiers auprès du client\n",
  },
  {
    id: 3,
    libelleGroupe:
      "De manière plus spécifique, les aspects suivants ont-ils été évalués :",
    libelle:
      "Le cabinet a-t-il presté des services non audit durant la période de son mandat de commissaire ?",
  },
  {
    id: 4,
    libelleGroupe:
      "De manière plus spécifique, les aspects suivants ont-ils été évalués :",
    libelle:
      "Les travaux d’audit ont-ils révélé des problèmes concernant l’intégrité du client ?",
  },
  {
    id: 5,
    libelleGroupe:
      "De manière plus spécifique, les aspects suivants ont-ils été évalués :",
    libelle:
      "Les travaux d’audit ont-ils révélé des problèmes relatifs à la compétence du cabinet de révision ?",
  },
  {
    id: 6,
    libelleGroupe:
      "De manière plus spécifique, les aspects suivants ont-ils été évalués :",
    libelle:
      "Plus particulièrement, aucun litige entre le cabinet ou un membre de l'équipe d'audit et le client n'est-il survenu ou susceptible de survenir ?",
  },
  {
    id: 7,
    libelleGroupe:
      "De manière plus spécifique, les aspects suivants ont-ils été évalués :",
    libelle:
      "Existe-t-il des raisons de supposer qu’à l’avenir surgiront des problèmes susceptibles de compromettre les travaux d’audit courants ?",
  },
  {
    id: 8,
    libelleGroupe:
      "De manière plus spécifique, les aspects suivants ont-ils été évalués :",
    libelle:
      "Faut-il tenir compte d’autres aspects afin de déterminer si un renouvellement de la mission est ou non indiquée ?",
  },
];

const questionsRefus = [
  {
    id: 1,
    libelleGroupe: "Questionnaire de refus",
    libelle:
      "Le questionnaire initial d'acceptation de la mission a-t-il été revu, actualisé et joint au présent document ?",
  },
  {
    id: 2,
    libelleGroupe: "Questionnaire de refus",
    libelle:
      "Sommes-nous toujours indépendants vis-à-vis de notre client (faire mention le cas échéant des motifs personnels graves existant) ?",
  },
  {
    id: 3,
    libelleGroupe: "Questionnaire de refus",
    libelle:
      "Des entraves ont-elles été mises à l’exercice de notre mission (en l’absence de motifs personnels graves) ?",
  },
  {
    id: 4,
    libelleGroupe: "Questionnaire de refus",
    libelle:
      "Nous voyons-nous confrontés à d’importantes divergences d’opinion avec la direction ?",
  },
];

const MaintienMission = ({ mission, client, code, prev }) => {
  const users = useUsers();
  const [activeStep, setActiveStep] = useState(0);
  const [identifications, setIdentifications] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(true);
  const [loading, setLoading] = useState(false);
  const [selectYear, setSelectYear] = useState(mission?.annee || "");
  const [missionSelected, setMissionSelected] = useState(mission);
  const [isProvisoire, setIsProvisoire] = useState("1");

  const [tache_id, setTache_id] = useState(null);
  const [user_id, setUser_id] = useState(null);
  const [date, setDate] = useState("");
  const [heureEntree, setHeureEntree] = useState("");
  const [intervention_id, setIntervention_id] = useState(null);

  const [affectValid, setAffectValid] = useState(false);
  const [maintenir, setMaintenir] = useState(false);
  const [acceptLoading, setAcceptLoading] = useState(true);
  const [isFileAdd, setIsFileAdd] = useState(false);
  const [associe_responsable, setAssocieResponsable] = useState(null);
  const [second_associer, setSecondAssocier] = useState(null);
  const [acceptData, setAcceptData] = useState([]);
  const [refusData, setRefusData] = useState([]);
  const [observation_generale, setObservation_generale] = useState("");
  const [auth, setAuth] = useState(false);
  const [conclusion, setConclusion] = useState(
    "Tenant compte des réponses mentionnées ci-dessus et considérant ma connaissance actuelle des faits, j’estime pouvoir offrir à nouveau nos services au client dans le cadre de la mission proposée et des conséquences prévisibles pour notre cabinet de révision.\n" +
      "\n" +
      "Nous sommes convaincus que le processus de renouvellement de la mission auprès du client peut être poursuivi.\n"
  );
  const conclusionText =
    "Tenant compte des réponses mentionnées ci-dessus et considérant ma connaissance actuelle des faits, j’estime pouvoir offrir à nouveau nos services au client dans le cadre de la mission proposée et des conséquences prévisibles pour notre cabinet de révision.\n" +
    "\n" +
    "Nous sommes convaincus que le processus de renouvellement de la mission auprès du client peut être poursuivi.\n";

  const codeSommaire = useMemo(() => code || "EB2", [code]);

  // ✅ 1. Ajouter un état pour tracker si les données ont été sauvegardées
  const [isQuestionSaved, setIsQuestionSaved] = useState(false); // Pour l'étape questionnaire
  const [isDecisionSaved, setIsDecisionSaved] = useState(false); // Pour l'étape décision

  // ✅ Ajouter un état pour forcer le re-render du composant DecisionMaintienRefus
  const [refusComponentKey, setRefusComponentKey] = useState(0);

  // ✅ Ajouter un état pour tracker l'initialisation des données de refus
  const [isRefusDataInitialized, setIsRefusDataInitialized] = useState(false);

  useEffect(() => {
    setAffectValid(
      missionSelected?.etat === 2 &&
        missionSelected &&
        missionSelected?.lettre_mission === 1
    );
    setIsFileAdd(missionSelected?.fichier_question === 1);
    setAssocieResponsable(missionSelected.associe_responsable);
    setSecondAssocier(missionSelected.second_associer);
  }, [missionSelected]);

  useEffect(() => {
    if (activeStep === 0) {
      const fetchIdentifications = async () => {
        const res = await getListeIdentificationSommaire(
          missionSelected.id,
          codeSommaire
        );
        setIdentifications(res.result);
      };

      fetchIdentifications();
    }
  }, [activeStep, codeSommaire, missionSelected]);

  // ✅ Fonction pour vérifier et mettre à jour les champs requis
  const updateMotifRequired = (data) => {
    return data.map((item) => ({
      ...item,
      motifRequired: !item.isCheckedN && !item.motif, // ✅ Requis si réponse négative ET pas de commentaire
    }));
  };

  // ✅ Modifier useEffect pour initialiser correctement les champs requis
  useEffect(() => {
    setLoading(true);
    const fetchMaintienData = async () => {
      getListeMaintienQuestion(missionSelected.id)
        .then((res) => {
          if (res) {
            if (
              res.Lea_ExerciceMaintienQuestions &&
              res.Lea_ExerciceMaintienQuestions.length > 0
            ) {
              setAcceptLoading(!res.Lea_ExerciceMaintienQuestions[0]?.isAccept);
              setMaintenir(res.Lea_ExerciceMaintienQuestions[0]?.isAccept);
              setIsQuestionSaved(true);

              const datas = res.Lea_ExerciceMaintienQuestions.map((item) => {
                return {
                  question_id: item.question_id,
                  libelle: item.libelle,
                  isCheckedN: Boolean(item.reponseN),
                  isCheckedN_1: Boolean(item.reponseN_1),
                  motifRequired:
                    !Boolean(item.reponseN) &&
                    (!item.commentaire || item.commentaire.trim() === ""),
                  motif: item.commentaire || "",
                };
              });

              setAcceptData(datas);
              setConclusion(res.conclusion || "");
              setObservation_generale(res.observation_generale || "");
              setAssocieResponsable(res.associe_responsable || null);
              setSecondAssocier(res.second_associer || null);

              if (res.associe_responsable || res.conclusion) {
                setIsDecisionSaved(true);
              }

              setLoading(false);
            } else {
              setIsQuestionSaved(false);
              setIsDecisionSaved(false);

              const defaultData = questionAcceptations.map((q) => ({
                question_id: q.id,
                libelle: q.libelle, // ✅ Corriger "lible" → "libelle"
                isCheckedN: false,
                isCheckedN_1: false,
                motifRequired: true,
                motif: "",
              }));

              setAcceptData(defaultData);
              setLoading(false);
            }
          }
        })
        .catch((error) => {
          console.error(
            "Erreur lors du chargement des données:",
            error.message
          );
          setLoading(false);
        });
    };

    if (missionSelected) {
      fetchMaintienData();
    }
  }, [missionSelected]);

  // ✅ 2. Corriger handleCheckboxChange pour utiliser "libelle" au lieu de "lible"
  const handleCheckboxChange = (isChecked) => {
    setLoading(true);
    setMaintenir(isChecked);

    if (!isChecked) {
      // Mode REFUSER
      setAcceptLoading(false);
      setRefusComponentKey((prev) => prev + 1);
      setRefusData([]);
      setIsRefusDataInitialized(false);

      setTimeout(() => {
        const defaultRefusData = questionsRefus.map((q) => ({
          question_id: q.id,
          libelle: q.libelle, // ✅ Corriger "lible" → "libelle"
          isCheckedN: false,
          isCheckedN_1: false,
          motifRequired: true,
          motif: "",
        }));

        console.log("Initialisation données refus:", defaultRefusData);
        setRefusData(defaultRefusData);
        setIsRefusDataInitialized(true);
      }, 50);
    } else {
      // Mode MAINTENIR
      setAcceptLoading(false);
      setRefusData([]);
      setIsRefusDataInitialized(false);
    }

    setTimeout(() => {
      setLoading(false);
    }, 100);
  };

  // ✅ 3. Corriger le useEffect pour les données de refus
  useEffect(() => {
    if (!maintenir) {
      if (refusData.length === 0) {
        const defaultRefusData = questionsRefus.map((q) => ({
          question_id: q.id,
          libelle: q.libelle, // ✅ Corriger "lible" → "libelle"
          isCheckedN: false,
          isCheckedN_1: false,
          motifRequired: true,
          motif: "",
        }));
        setRefusData(defaultRefusData);
      }
      setIsRefusDataInitialized(true);
      setAcceptLoading(false);
    } else {
      setRefusData([]);
      setIsRefusDataInitialized(false);
    }
  }, [maintenir]);

  // ✅ 4. Corriger handleSubmit pour la typo dans refusData
  const handleSubmit = async () => {
    setLoading(true);

    if (activeStep === 2) {
      // Étape questionnaire - Vérifier les champs requis
      const missingComments = acceptData.filter(
        (item) => !item.isCheckedN && (!item.motif || item.motif.trim() === "")
      );

      if (missingComments.length > 0) {
        notification.error({
          message: "Champs obligatoires manquants",
          description: `Veuillez renseigner les commentaires pour les réponses négatives (${missingComments.length} commentaire(s) manquant(s))`,
          duration: 5,
        });
        setLoading(false);
        return;
      }

      // ✅ Préparer les données avec mapping correct des commentaires
      const dataQuestion = {
        intervention_id,
        date,
        heureEntree,
        tache_id,
        user_id,
        codeSommaire,
        exercice_id: mission.id,
        client_id: client.id,
        datas: acceptData.map((item) => ({
          question_id: item.question_id,
          libelle: item.libelle,
          reponseN: item.isCheckedN,
          reponseN_1: item.isCheckedN_1,
          commentaire: item.motif || "",
        })),
      };

      const { status, message } = await ajoutMaintienQuestion(dataQuestion);

      if (status === "success") {
        setLoading(false);
        setAuth(false);
        setIsQuestionSaved(true);
        await swal(succesMessage, "", "success");
      } else {
        await swal(message, "", "error");
        setLoading(false);
      }
    } else if (activeStep === 3) {
      // ✅ Validation pour REFUS - Questionnaire + Affectation
      if (!maintenir) {
        console.log("Validation des données de refus:", refusData);

        if (!refusData || refusData.length === 0) {
          notification.error({
            message: "Erreur de données",
            description:
              "Les données du questionnaire de refus ne sont pas initialisées correctement",
            duration: 5,
          });
          setLoading(false);
          return;
        }

        const missingRefusComments = refusData.filter((item) => {
          const isNegative = !item.isCheckedN;
          const hasNoComment = !item.motif || item.motif.trim() === "";
          return isNegative && hasNoComment;
        });

        if (missingRefusComments.length > 0) {
          notification.error({
            message: "Champs obligatoires manquants",
            description: `Veuillez renseigner les commentaires pour les réponses négatives du questionnaire de refus (${missingRefusComments.length} commentaire(s) manquant(s))`,
            duration: 5,
          });
          setLoading(false);
          return;
        }

        // ✅ Validation de l'affectation obligatoire AUSSI pour le refus
        if (!associe_responsable) {
          notification.error({
            message: "Champ obligatoire manquant",
            description:
              "Veuillez sélectionner un associé responsable pour finaliser le processus de refus",
            duration: 5,
          });
          setLoading(false);
          return;
        }

        if (!second_associer) {
          notification.error({
            message: "Champ obligatoire manquant",
            description:
              "Veuillez sélectionner un second associé pour finaliser le processus de refus",
            duration: 5,
          });
          setLoading(false);
          return;
        }
      }

      // ✅ Validation pour MAINTIEN - Conclusion + Affectation
      if (maintenir) {
        if (!conclusion || conclusion.trim() === "") {
          notification.error({
            message: "Champ obligatoire manquant",
            description:
              "Veuillez saisir une conclusion pour le maintien de la mission",
            duration: 5,
          });
          setLoading(false);
          return;
        }

        if (!associe_responsable) {
          notification.error({
            message: "Champ obligatoire manquant",
            description:
              "Veuillez sélectionner un associé responsable pour l'affectation du dossier",
            duration: 5,
          });
          setLoading(false);
          return;
        }

        if (!second_associer) {
          notification.error({
            message: "Champ obligatoire manquant",
            description:
              "Veuillez sélectionner un second associé pour l'affectation du dossier",
            duration: 5,
          });
          setLoading(false);
          return;
        }
      }

      // ✅ Préparer les données pour l'API (maintien ET refus)
      const dataAffection = {
        intervention_id,
        date,
        heureEntree,
        tache_id,
        user_id,
        codeSommaire,
        conclusion,
        isAccept: maintenir,
        exercice_id: mission.id,
        client_id: client.id,
        associe_responsable, // ✅ Obligatoire pour maintien ET refus
        second_associer, // ✅ Obligatoire pour maintien ET refus
        observation_generale,
        questionnaireData: acceptData.map((item) => ({
          question_id: item.question_id,
          libelle: item.libelle,
          reponseN: item.isCheckedN,
          reponseN_1: item.isCheckedN_1,
          commentaire: item.motif || "",
        })),
        refusData: !maintenir
          ? refusData.map((item) => ({
              question_id: item.question_id,
              libelle: item.libelle,
              reponseN: item.isCheckedN,
              reponseN_1: item.isCheckedN_1,
              commentaire: item.motif || "",
            }))
          : null,
      };

      const { status, message } = await ajoutMaintienAffectation(dataAffection);

      if (status === "success") {
        setLoading(false);
        setAuth(false);
        setIsDecisionSaved(true);
        await swal(succesMessage, "", "success");
      } else {
        await swal(message, "", "error");
        setLoading(false);
      }
    }
  };

  // ✅ Ajouter les fonctions manquantes

  // ✅ 1. Fonction pour mettre à jour les données d'acceptation
  const updateQuestionDataCallback = useCallback((updatedData) => {
    console.log("Mise à jour des données d'acceptation:", updatedData);

    const dataWithRequiredFields = updatedData.map((item) => ({
      ...item,
      motifRequired:
        !item.isCheckedN && (!item.motif || item.motif.trim() === ""),
      motif: item.motif || "",
    }));

    setAcceptData(dataWithRequiredFields);
  }, []);

  // ✅ 2. Fonction pour mettre à jour les données de refus
  const updateRefusData = useCallback((updatedData) => {
    console.log("Mise à jour des données de refus:", updatedData);

    const dataWithRequiredFields = updatedData.map((item) => ({
      ...item,
      motifRequired:
        !item.isCheckedN && (!item.motif || item.motif.trim() === ""),
      motif: item.motif || "",
    }));

    setRefusData(dataWithRequiredFields);
  }, []);

  // ✅ 3. Fonction pour vérifier l'état de sauvegarde
  const getCurrentStepSavedStatus = () => {
    switch (activeStep) {
      case 2: // Questionnaire de maintien
        return isQuestionSaved;
      case 3: // Décision et affectation
        return isDecisionSaved;
      default:
        return false;
    }
  };

  // ✅ 4. Fonctions de navigation
  const handleNextStep = (e) => {
    e.preventDefault();
    if (isFileAdd) {
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handlePrevStep = (e) => {
    e.preventDefault();
    setActiveStep((prevStep) => prevStep - 1);
  };

  const isLastStep = () => {
    return activeStep === formSteps.length - 1;
  };

  useEffect(() => {
    if (activeStep === 0) {
      const fetchIdentifications = async () => {
        const res = await getListeIdentificationSommaire(
          missionSelected.id,
          codeSommaire
        );
        setIdentifications(res.result);
      };

      fetchIdentifications();
    }
  }, [activeStep, codeSommaire, missionSelected]);

  // ✅ Ajouter un useEffect pour surveiller les changements de refusData
  useEffect(() => {
    console.log("RefusData mis à jour:", refusData);
  }, [refusData]);

  // ✅ Ajouter un useEffect pour surveiller les changements d'acceptData
  useEffect(() => {
    console.log("AcceptData mis à jour:", acceptData);
  }, [acceptData]);

  const formSteps = [
    {
      code: "ID",
      title: "IDENTIFICATIONS",
      icon: faIdCard,
      content: (
        <UserCycleIdentification
          setDate={setDate}
          dateDebut={date}
          setTache_id={setTache_id}
          setIntervention_id={setIntervention_id}
          setHeureEntree={setHeureEntree}
          setUser_id={setUser_id}
          mission={mission}
          prev={prev}
          loading={loading}
          codeSommaire={codeSommaire}
          setIsAuthorized={setAuth}
          isAuthorized={auth}
          setActiveStep={setActiveStep}
        />
      ),
    },
    {
      code: "EB2.0",
      title: `Formulaire de maintien - ${selectYear}`,
      icon: faTasks,
      content: (
        <FileUploadQuestionnaire
          setIsFileAdd={setIsFileAdd}
          isFileAdd={isFileAdd}
          exercice={missionSelected}
          client={client}
          codeSommaire={codeSommaire}
          chargement={loading}
        />
      ),
    },
    {
      code: "EB2.2",
      title: `Questionnaire de maintien - ${selectYear}`,
      icon: faTasks,
      content: (
        <QuestionnaireMaintien
          mission={missionSelected}
          questions={questionAcceptations}
          acceptLoading={acceptLoading}
          setQuestionData={updateQuestionDataCallback} // ✅ Maintenant définie
          conclusion={conclusion}
          setConclusion={setConclusion}
          questionsData={acceptData}
          chargement={loading}
          affectValid={affectValid}
          isDecisionSaved={isQuestionSaved}
          key={`questionnaire-${missionSelected?.id}`}
        />
      ),
    },
    {
      code: "EB2.4",
      title: `Décision et affection du dossier - ${selectYear}`,
      icon: faTasks,
      content: (
        <>
          <div className="px-3 pt-15">
            <div className="card-header">
              <div className="card-title">
                <Title
                  style={{
                    display: "block",
                    fontWeight: "600",
                    color: appTheme.colors.primary_blue,
                  }}
                  level={3}
                >
                  EB2.4: Décision et affectation du dossier
                </Title>
              </div>
            </div>

            {/* ✅ Afficher le résumé du questionnaire de maintien */}
            <div className="my-10">
              <div className="card-title mb-3">
                <Title
                  style={{
                    fontSize: "18px",
                    display: "block",
                    fontWeight: "600",
                    color: appTheme.colors.primary,
                  }}
                  level={4}
                >
                  Résumé du questionnaire de maintien :
                </Title>
              </div>

              {/* ✅ Tableau récapitulatif - utiliser SEULEMENT acceptData */}
              <div className="table-responsive">
                <table className="table table-bordered">
                  <thead style={{ backgroundColor: "#f5f5f5" }}>
                    <tr>
                      <th style={{ width: "5%", textAlign: "center" }}>N°</th>
                      <th style={{ width: "60%" }}>Question</th>
                      <th style={{ width: "10%", textAlign: "center" }}>
                        Réponse
                      </th>
                      <th style={{ width: "25%" }}>Commentaire</th>
                    </tr>
                  </thead>
                  <tbody>
                    {acceptData.map((item, index) => (
                      <tr key={item.question_id || index}>
                        <td style={{ textAlign: "center", fontWeight: "bold" }}>
                          {index + 1}
                        </td>
                        <td style={{ fontSize: "11px", lineHeight: "1.3" }}>
                          {/* ✅ Utiliser directement item.libelle sans référence à questionAcceptations */}
                          {item.libelle}
                        </td>
                        <td style={{ textAlign: "center" }}>
                          <span
                            className={`badge ${
                              item.isCheckedN
                                ? "badge-light-success"
                                : "badge-light-danger"
                            }`}
                            style={{
                              fontSize: "10px",
                              padding: "4px 8px",
                            }}
                          >
                            {item.isCheckedN ? "OUI" : "NON"}
                          </span>
                        </td>
                        <td style={{ fontSize: "10px" }}>
                          {item.motif || "-"}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* ✅ Afficher un résumé des réponses négatives nécessitant des commentaires */}
            {acceptData.some((item) => !item.isCheckedN) && (
              <div className="my-10">
                <div className="alert alert-warning">
                  <strong>Information :</strong> Des commentaires sont requis
                  pour les réponses négatives dans le questionnaire.
                  <br />
                  <small>
                    Questions avec réponses négatives :{" "}
                    {acceptData.filter((item) => !item.isCheckedN).length}
                  </small>
                </div>
              </div>
            )}

            {/* ✅ Conclusion automatique basée sur les réponses */}
            <div className="my-10">
              <div className="card-title mb-2">
                <Title
                  style={{
                    fontSize: "16px",
                    display: "block",
                    fontWeight: "600",
                    color: appTheme.colors.primary,
                  }}
                  level={5}
                >
                  Conclusion du questionnaire :
                </Title>
              </div>

              <div className="alert alert-info">
                {acceptData.filter((item) => !item.isCheckedN).length === 0 ? (
                  <div>
                    <strong>✓ Toutes les réponses sont positives</strong>
                    <br />
                    <small>
                      Aucun élément ne s'oppose au maintien de la mission.
                    </small>
                  </div>
                ) : (
                  <div>
                    <strong>
                      ⚠ {acceptData.filter((item) => !item.isCheckedN).length}{" "}
                      réponse(s) négative(s) identifiée(s)
                    </strong>
                    <br />
                    <small>
                      Une analyse détaillée des commentaires est nécessaire pour
                      prendre une décision.
                    </small>
                  </div>
                )}
              </div>
            </div>

            <div className="my-10">
              <div className="card-title mb-2">
                <Title
                  style={{
                    fontSize: "24px",
                    display: "block",
                    fontWeight: "600",
                    color: appTheme.colors.primary,
                  }}
                  level={5}
                >
                  # A mon avis nous devrions:
                </Title>
              </div>
              <div
                className="row g-9"
                data-kt-buttons="true"
                data-kt-buttons-target="[data-kt-button='true']"
              >
                <div className="col">
                  <label
                    className={`btn btn-outline btn-outline-dashed btn-outline-${
                      maintenir ? "primary text-hover-white" : "default"
                    } d-flex text-start p-6`}
                    data-kt-button="true"
                  >
                    <span className="form-check form-check-custom form-check-sm align-items-start mt-1">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="campaign_gender_1"
                        disabled={
                          mission.isCloture === 1 ||
                          mission.isClotureProvisoire === 1 ||
                          affectValid ||
                          isDecisionSaved
                        }
                        checked={maintenir}
                        onChange={(e) => {
                          handleCheckboxChange(e.target.checked);
                          setConclusion(conclusionText);
                        }}
                      />
                    </span>
                    <span className="ms-5">
                      <span
                        style={{
                          fontSize: "24px",
                          fontWeight: "700",
                          fontFamily: "Oswald",
                        }}
                        className={`text-gray-800 text-hover-white d-block`}
                      >
                        MAINTENIR
                      </span>
                    </span>
                  </label>
                </div>
                <div className="col">
                  <label
                    className={`btn btn-outline btn-outline-dashed btn-outline-${
                      !maintenir ? "danger" : "default"
                    } d-flex text-start p-6`}
                    data-kt-button="true"
                  >
                    <span className="form-check form-check-custom form-check-sm align-items-start mt-1">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="accept"
                        disabled={
                          mission.isCloture === 1 ||
                          mission.isClotureProvisoire === 1 ||
                          affectValid ||
                          isDecisionSaved
                        }
                        checked={!maintenir}
                        onChange={(e) => {
                          handleCheckboxChange(!e.target.checked);
                          setConclusion("");
                          setAssocieResponsable("");
                          setSecondAssocier("");
                        }}
                      />
                    </span>
                    <span className="ms-5">
                      <span
                        style={{
                          fontSize: "24px",
                          fontWeight: "700",
                          fontFamily: "Oswald",
                        }}
                        className={`text-gray-800 text-hover-white d-block`}
                      >
                        REFUSER
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            </div>

            <div className="align-center">
              <div className="w-100 p-5">
                <div className="">
                  {/* ✅ Condition de chargement simplifiée et plus précise */}
                  {loading ? (
                    <Skeleton active />
                  ) : (
                    <>
                      {maintenir ? (
                        <div className="d-flex flex-column my-7">
                          <FormLabel required label="Conclusion :" />
                          <Input.TextArea
                            size="large"
                            placeholder="Saisissez la conclusion pour le maintien"
                            required={maintenir && !conclusion}
                            value={conclusion}
                            readOnly={
                              mission.isCloture === 1 ||
                              mission.isClotureProvisoire === 1 ||
                              affectValid ||
                              isDecisionSaved
                            }
                            onChange={(e) => {
                              setConclusion(e.target.value);
                            }}
                            style={{
                              width: "100%",
                              border:
                                maintenir && !conclusion
                                  ? "1px solid red"
                                  : "0",
                            }}
                            showCount
                            maxLength={5000}
                            autoSize={{
                              minRows: 6,
                              maxRows: 10,
                            }}
                          />
                          {maintenir && !conclusion && (
                            <div className="text-danger">
                              Champ obligatoire *
                            </div>
                          )}
                        </div>
                      ) : (
                        // ✅ Questionnaire de refus
                        !maintenir &&
                        refusData.length > 0 &&
                        isRefusDataInitialized && (
                          <div
                            key={`refus-${refusComponentKey}-${refusData.length}`}
                          >
                            {console.log(
                              "Données refusData passées au composant:",
                              refusData
                            )}

                            <DecisionMaintienRefus
                              mission={missionSelected}
                              questions={questionsRefus}
                              loading={false}
                              acceptLoading={false}
                              setQuestionData={updateRefusData}
                              conclusion={conclusion}
                              setConclusion={setConclusion}
                              questionsData={refusData}
                              maintenir={maintenir}
                              affectValid={false}
                              isDecisionSaved={false}
                            />
                          </div>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>

            <Divider />

            {/* ✅ Section Affectation du dossier - Afficher pour MAINTENIR ET REFUSER */}
            <div className="w-100">
              <div className="card-title mb-2">
                <Title
                  style={{
                    fontSize: "24px",
                    display: "block",
                    fontWeight: "600",
                    color: appTheme.colors.primary,
                  }}
                  level={5}
                >
                  # Affectation du dossier:
                </Title>
              </div>

              {/* ✅ Message d'information différent selon maintien/refus */}
              {/* <div className="alert alert-info mb-4">
                <strong>Information :</strong>
                {maintenir
                  ? ' Les champs "Associé responsable" et "Second associé" sont obligatoires pour finaliser l\'affectation du dossier en cas de maintien.'
                  : ' Les champs "Associé responsable" et "Second associé" sont obligatoires pour finaliser le processus de refus et archiver le dossier.'}
              </div> */}

              {/* ✅ Section ASSOCIE RESPONSABLE - Obligatoire pour maintien ET refus */}
              <div className="d-flex">
                <div className="col-lg-1">
                  <FontAwesomeIcon
                    icon={faUserCircle}
                    size={"3x"}
                    color={appTheme.colors.primary_blue}
                  />
                </div>
                <div className="col-lg-6">
                  <Space.Compact block>
                    <Input
                      size="large"
                      style={{
                        width: "30%",
                        fontWeight: "400",
                      }}
                      value="ASSOCIE RESPONSABLE *"
                      readOnly={true}
                    />
                    {mission.isCloture === 1 ||
                    mission.isClotureProvisoire === 1 ||
                    affectValid ? (
                      <Input
                        size="large"
                        style={{
                          width: "70%",
                          fontWeight: "700",
                          textTransform: "uppercase",
                        }}
                        value={`${
                          users.users?.find(
                            (user) => user.id === associe_responsable
                          )?.initial || ""
                        } - ${
                          users.users?.find(
                            (user) => user.id === associe_responsable
                          )?.nom_user || ""
                        } ${
                          users.users?.find(
                            (user) => user.id === associe_responsable
                          )?.prenom_user || ""
                        }`}
                        readOnly={true}
                      />
                    ) : (
                      <Select
                        showSearch
                        placeholder="Sélectionnez l'associé responsable *"
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={associe_responsable || null}
                        disabled={
                          mission.isCloture === 1 ||
                          mission.isClotureProvisoire === 1 ||
                          affectValid ||
                          isDecisionSaved
                        }
                        options={users?.users?.map((user) => ({
                          value: user.id,
                          label: (
                            <span className="fw-boldest fs-5 text-uppercase">{`${
                              user.initial || ""
                            } - ${user.nom_user || ""} ${
                              user.prenom_user || ""
                            }`}</span>
                          ),
                        }))}
                        onChange={(value) => setAssocieResponsable(value)}
                        size="large"
                        style={{
                          width: "70%",
                          border: !associe_responsable
                            ? "1px solid #ff4d4f"
                            : undefined,
                        }}
                      />
                    )}
                  </Space.Compact>
                  {/* ✅ Message d'erreur pour maintien ET refus */}
                  {!associe_responsable && !isDecisionSaved && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Champ obligatoire *
                    </div>
                  )}
                </div>
              </div>
              <br />
              <br />

              {/* ✅ Section SECOND ASSOCIE - Obligatoire pour maintien ET refus */}
              <div className="d-flex">
                <div className="col-lg-1">
                  <FontAwesomeIcon
                    icon={faUserCircle}
                    size={"3x"}
                    color={appTheme.colors.primary_blue}
                  />
                </div>
                <div className="col-lg-6">
                  <Space.Compact block>
                    <Input
                      size="large"
                      style={{
                        width: "30%",
                        fontWeight: "400",
                      }}
                      value="SECOND ASSOCIE *"
                      readOnly={true}
                    />
                    {mission.isCloture === 1 ||
                    mission.isClotureProvisoire === 1 ||
                    affectValid ? (
                      <Input
                        size="large"
                        style={{
                          width: "70%",
                          fontWeight: "700",
                          textTransform: "uppercase",
                        }}
                        value={`${
                          users.users?.find(
                            (user) => user.id === second_associer
                          )?.initial || ""
                        } - ${
                          users.users?.find(
                            (user) => user.id === second_associer
                          )?.nom_user || ""
                        } ${
                          users.users?.find(
                            (user) => user.id === second_associer
                          )?.prenom_user || ""
                        }`}
                        readOnly={true}
                      />
                    ) : (
                      <Select
                        showSearch
                        placeholder="Sélectionnez le second associé *"
                        optionFilterProp="label"
                        filterOption={(input, option) =>
                          option.label
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                        value={second_associer || null}
                        disabled={
                          mission.isCloture === 1 ||
                          mission.isClotureProvisoire === 1 ||
                          affectValid ||
                          isDecisionSaved
                        }
                        options={users?.users?.map((user) => ({
                          value: user.id,
                          label: (
                            <span className="fw-boldest fs-5 text-uppercase">{`${
                              user.initial || ""
                            } - ${user.nom_user || ""} ${
                              user.prenom_user || ""
                            }`}</span>
                          ),
                        }))}
                        onChange={(value) => setSecondAssocier(value)}
                        size="large"
                        style={{
                          width: "70%",
                          border: !second_associer
                            ? "1px solid #ff4d4f"
                            : undefined,
                        }}
                      />
                    )}
                  </Space.Compact>
                  {/* ✅ Message d'erreur pour maintien ET refus */}
                  {!second_associer && !isDecisionSaved && (
                    <div
                      className="text-danger mt-1"
                      style={{ fontSize: "12px" }}
                    >
                      Champ obligatoire *
                    </div>
                  )}
                </div>
              </div>

              {/* ✅ Ajouter une section d'observation générale pour le refus */}
              {!maintenir && (
                <div className="mt-5">
                  <div className="d-flex flex-column my-4">
                    <FormLabel label="Observation générale (optionnel) :" />
                    <Input.TextArea
                      size="large"
                      placeholder="Ajoutez des observations générales concernant le refus de la mission..."
                      value={observation_generale}
                      readOnly={
                        mission.isCloture === 1 ||
                        mission.isClotureProvisoire === 1 ||
                        affectValid ||
                        isDecisionSaved
                      }
                      onChange={(e) => {
                        setObservation_generale(e.target.value);
                      }}
                      style={{ width: "100%" }}
                      showCount
                      maxLength={2000}
                      autoSize={{
                        minRows: 3,
                        maxRows: 6,
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      ),
    },
  ];

  return (
    <>
      <div className="mx-5">
        <PageToolbarHeader
          prev={prev}
          codeSommaire={codeSommaire}
          pageTitle={"EB2 - Maintien de la mission"}
          mission={missionSelected}
          setMission={setMissionSelected}
          isProvisoire={isProvisoire}
          setIsProvisoire={setIsProvisoire}
          selectYear={selectYear}
          setSelectYear={setSelectYear}
          loading={loading}
          setLoading={setLoading}
          client={client}
          setIsModalOpen={setIsModalOpen}
          isModalOpen={isModalOpen}
          setDate={setDate}
          setTache_id={setTache_id}
          tache_id={tache_id}
          setIntervention_id={setIntervention_id}
          intervention_id={intervention_id}
          setHeureEntree={setHeureEntree}
          setUser_id={setUser_id}
        />
        <StepHeader>
          <ModalNavBarMenu
            setActiveTab={setActiveStep}
            activeTab={activeStep}
            steps={formSteps}
            setLoading={setLoading}
            loading={loading}
            auth={auth}
          />
        </StepHeader>
        <StepBody>{formSteps[activeStep].content}</StepBody>
        <div style={{ textAlign: "center" }}>
          {activeStep >= 1 && (
            <Button
              size="large"
              onClick={handlePrevStep}
              style={{ marginRight: "20px" }}
            >
              Précédent
            </Button>
          )}
          {!isLastStep() && (
            <Button
              size="large"
              onClick={handleNextStep}
              style={{
                marginRight: "20px",
                backgroundColor: appTheme.colors.primary_blue,
                color: "white",
              }}
            >
              Suivant
            </Button>
          )}
          {activeStep > 1 &&
            (loading ? (
              <Spinner ml={"10px"} />
            ) : (
              mission.isCloture !== 1 &&
              mission.isClotureProvisoire !== 1 &&
              !affectValid && (
                <Button
                  size="large"
                  type="primary"
                  onClick={handleSubmit}
                  disabled={getCurrentStepSavedStatus()} // ✅ Maintenant définie
                  style={{
                    marginRight: "20px",
                    opacity: getCurrentStepSavedStatus() ? 0.6 : 1,
                  }}
                >
                  {getCurrentStepSavedStatus()
                    ? "Déjà enregistré"
                    : "Enregistrer"}
                </Button>
              )
            ))}
          <Button size="large" danger onClick={() => prev()}>
            Annuler
          </Button>
        </div>
      </div>
    </>
  );
};

export { MaintienMission };
